export enum DndItemType {
  SLOT = 'edit-scene-slot',
}
